import PropTypes from 'prop-types';
import PaymentProps from './payment';
import ReviewProps from './review';

export default {
	...PaymentProps,
	...ReviewProps,
	ewOutcome: PropTypes.shape({
		effective_warning: PropTypes.shape({
			next_step: PropTypes.string,
			effective_warning_id: PropTypes.string,
		}).isRequired,
		additional_questions: PropTypes.arrayOf(
			PropTypes.shape({
				question: PropTypes.string,
				question_id: PropTypes.number,
			})
		),
		additional_questions_answers: PropTypes.arrayOf(
			PropTypes.shape({
				question_id: PropTypes.number,
				answer_id: PropTypes.number,
				answer: PropTypes.string,
			})
		),
	}),
	paymentReasons: PropTypes.arrayOf(
		PropTypes.shape({
			payment_reason_id: PropTypes.string,
			payment_reason: PropTypes.string,
			additional_details: PropTypes.string,
		})
	),
	fromAccount: PropTypes.shape({
		id: PropTypes.string,
		balances: PropTypes.arrayOf(
			PropTypes.shape({
				type: PropTypes.string,
				amount: PropTypes.number,
				currency: PropTypes.string,
			})
		),
	}),
	toAccount: PropTypes.shape({
		id: PropTypes.string,
		to_account: PropTypes.shape({
			sort_code: PropTypes.string,
			account_number: PropTypes.string,
			name: PropTypes.string,
		}),
	}),
	payee: PropTypes.shape({
		id: PropTypes.string,
		to_account: PropTypes.shape({
			sort_code: PropTypes.string,
			account_number: PropTypes.string,
			name: PropTypes.string,
		}),
	}),
};
